var subcriptionPercentage = $(".js-subscription-percentage").text();
var calculaterSubscriptionPercentage = (100-subcriptionPercentage)/100;
console.log("subcriptionPercentage: " + calculaterSubscriptionPercentage);
$(document).ready(function ($) {

  $(".js-two-column-carousel-with-content").owlCarousel({
    loop: false,
    margin: 28,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: true,
    autoplay: false,
    autoHeight: true,
    items: 1,
    autoplayTimeout: 5000
  });
  $('#Product-related-slider').owlCarousel({
    loop: true,
    margin: 12,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoHeight: true,
    items: 4,
    stagePadding: 0,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 1,
        dots: true,
        nav: false,
      },
      450: {
        items: 2,
      },
      660: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });







  
  loopThroughCouponCodeArrayToShowMessageOnPDP();
  /* Blog: Hide tha tag list and open a dropdown type list for the tags */
  $(".mobileBlogCategoryView").click(function (e) {
    if ($(".blogCategorySection").css("display") == "none") {
      $(".blogCategorySection").slideDown();
      $(".mobileBlogCategoryView").addClass("active");
    } else {
      $(".blogCategorySection").slideUp();
      $(".mobileBlogCategoryView").removeClass("active");
    }
  });
  $(".blogCategorySection")
    .children("li")
    .each(function () {
      if ($(this).children("a").hasClass("active")) {
        $(".mobileBlogCategoryView").html($(this).children("a").html());
        $(this).hide();
      }
    });
  /* PDP Make the Tab section background white - when there is no video */
  // if ($(".videoBlock").html() == undefined) {
  //   $(".productTabSection").addClass("white-bg");
  // }
  /* Slider for product images in the product details page */
  var $productDetailImages = $(".productDetailImages").owlCarousel({
    loop: false,
    margin: 0,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoplayTimeout: 5000,
    autoHeight: true,
    items: 1,
  });
 
  /*PDP: Hide the doctor images in the slider when the doctor isn't logged in*/
  var valueOfDoctorLoggedIn = $("#js-check-if-doctor-loggedin").html();
  valueOfDoctorLoggedIn = $.trim(valueOfDoctorLoggedIn);
  if (valueOfDoctorLoggedIn == "") {
    $(".productDetailImages .owl-item").each(function () {
      var srcimage = $(this).children("li").children("img").attr("src");
      if (srcimage.trim().indexOf("-doctor") != -1) {
        $(this).remove();
      }
    });
    $productDetailImages.trigger("destroy.owl.carousel");
    $productDetailImages = $(".productDetailImages").owlCarousel({
      loop: false,
      margin: 0,
      nav: true,
      mouseDrag: false,
      touchDrag: true,
      dots: false,
      autoplay: false,
      autoplayTimeout: 5000,
      autoHeight: true,
      items: 1,
    });
  }

  /* Thumbnail strip under the main product image (drag/swipe only, no arrows) */
  var $productImageThumbs = $(".product-image-thumbs");
  if ($productImageThumbs.length) {
    if (valueOfDoctorLoggedIn == "") {
      $productImageThumbs.find("img").each(function () {
        var srcimage = $(this).attr("src");
        if (srcimage && srcimage.indexOf("-doctor") != -1) {
          $(this).closest("li").remove();
        }
      });
      $productImageThumbs.find(".product-image-thumb").each(function (i) {
        $(this).attr("data-index", i);
        $(this).toggleClass("is-active", i === 0);
      });
    }

    $productImageThumbs.owlCarousel({
      loop: false,
      margin: 10,
      nav: false,
      dots: false,
      mouseDrag: true,
      touchDrag: true,
      autoplay: false,
      items: 5,
      responsive: {
        0: { items: 3 },
        481: { items: 4 },
        769: { items: 5 },
      },
    });

    function setActiveThumb(index) {
      if (isNaN(index) || index < 0) return;
      $productImageThumbs.find(".product-image-thumb").removeClass("is-active");
      var $thumb = $productImageThumbs.find(
        '.product-image-thumb[data-index="' + index + '"]'
      );
      if (!$thumb.length) return;
      $thumb.addClass("is-active");
      $productImageThumbs.trigger("to.owl.carousel", [index, 200]);
    }

    $productImageThumbs.on("click", ".product-image-thumb", function () {
      var index = parseInt($(this).attr("data-index"), 10);
      if (isNaN(index)) return;
      $productDetailImages.trigger("to.owl.carousel", [index, 200]);
      setActiveThumb(index);
    });

    $productDetailImages.on("changed.owl.carousel", function (event) {
      if (!event.item || event.item.count === 0) return;
      // With loop/clones, event.item.index is absolute; relative() is the real slide.
      var index = event.relatedTarget.relative(event.item.index);
      setActiveThumb(index);
    });
  }

  $(".js-three-column-product-list-carousel").owlCarousel({
    loop: true,
    stagePadding: 62.5,
    margin: 0,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoHeight: true,
    items: 3,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        dots: true,
        nav: false,
      },
      481: {
        items: 2,
        stagePadding: 0,
      },
      601: {
        items: 2,
        stagePadding: 30,
      },
      992: {
        items: 3,
        stagePadding: 62.5,
      }
    },
  });


  $(".productshopList").owlCarousel({
    loop: true,
    stagePadding: 62.5,
    margin: 0,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoHeight: true,
    items: 4,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        dots: true,
        nav: false,
      },
      481: {
        items: 2,
        stagePadding: 0,
      },
      601: {
        items: 2,
        stagePadding: 30,
      },
      992: {
        items: 3,
        stagePadding: 62.5,
      },
      1200: {
        items: 4,
        stagePadding: 62.5,
      },
    },
  });

  $(".js__offer-testimonial").owlCarousel({
    loop: true,
   
    margin: 0,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoHeight: true,
    items: 1,
    autoplayTimeout: 5000,
    
  });
  /* Header Nav Product Hover mouseover/mouseout */

// Toggle first-level submenu
$(".nav-product-subMenu-hover").click(function (event) {
  event.stopPropagation(); // Prevents click from bubbling up
  let $submenu = $(".nav-ProductSubMenuOuter");

  // Close other menus before opening this one
  $(".awemenu-submenu").slideUp();
  $(".awemenu-submenu").css("visibility","hidden");
  $(".awemenu-submenu").css("opacity","0");
  $(".awemenu-submenu").css("display","hidden");
  $(".awemenu-item").removeClass("open");

  $submenu.toggle();
  $("#headerTopProductMenu").toggleClass("activeSubmenu");

  // Set background color based on submenu visibility
  $(".awemenu-nav").css("background-color", $submenu.is(":visible") ? "white" : "transparent");
});

// Toggle second-level submenus using `.sub-menu-link`
$(".sub-menu-link").click(function (event) {
  event.preventDefault();
  event.stopPropagation();

  let $submenu = $(this).siblings(".awemenu-submenu");

  // Close all other submenus and the first-level menu
  $(".awemenu-submenu").not($submenu).slideUp();
  $(".awemenu-item").not($(this).closest(".awemenu-item")).removeClass("open");
  $(".nav-ProductSubMenuOuter").hide(); // Close first-level menu
  $("#headerTopProductMenu").removeClass("activeSubmenu");

  // Toggle clicked submenu
  $submenu.slideToggle();
  $submenu.css("visibility","visible");
  $submenu.css("opacity","1");
  $submenu.css("display","block");
  $(this).closest(".awemenu-item").toggleClass("open");

  // Set background color if any submenu is open
  $(".awemenu-nav").css("background-color", $(".awemenu-submenu:visible").length > 0 ? "white" : "transparent");
});

// Close all menus when clicking outside
$(document).click(function (event) {
  if (!$(event.target).closest(".nav-product-subMenu-hover, .sub-menu-link, .awemenu-submenu").length) {
      $(".nav-ProductSubMenuOuter, .awemenu-submenu").hide();
      $(".awemenu-item").removeClass("open");
      $("#headerTopProductMenu").removeClass("activeSubmenu");
      $(".awemenu-nav").css("background-color", "transparent"); // Reset background
  }
});



  
  // $(".nav-product-subMenu-hover").click(function () {
  //   $(".nav-ProductSubMenuOuter").show();
  //   //console.log("porduct hover");
  //   $("#headerTopProductMenu").addClass("activeSubmenu");
  //   $(".awemenu-nav").css("background-color", "white");
  // });
  // $(".nav-product-subMenu-hover").mouseout(function () {
  //   $(".nav-ProductSubMenuOuter").hide();
  //   $("#headerTopProductMenu").removeClass("activeSubmenu");
  //   $(".awemenu-nav").css("background-color", "transparent");
  // });

//   $(".nav-product-subMenu-hover").click(function (event) {
//     event.stopPropagation(); // Prevents click from bubbling up
//     $(".nav-ProductSubMenuOuter").toggle(); // Toggle submenu visibility
//     $("#headerTopProductMenu").toggleClass("activeSubmenu");

//     // Set background color based on submenu visibility
//     if ($(".nav-ProductSubMenuOuter").is(":visible")) {
//         $(".awemenu-nav").css("background-color", "white");
//     } else {
//         $(".awemenu-nav").css("background-color", "transparent");
//     }
// });

// Close submenu when clicking outside
// $(document).click(function (event) {
//     if (!$(event.target).closest(".nav-product-subMenu-hover, .nav-ProductSubMenuOuter").length) {
//         $(".nav-ProductSubMenuOuter").hide();
//         $("#headerTopProductMenu").removeClass("activeSubmenu");
//         $(".awemenu-nav").css("background-color", "transparent"); // Reset background
//     }
// });
// $(".sub-menu-link").click(function (event) {
//   event.stopPropagation(); // Prevents click from bubbling up
//   $(".awemenu-submenu.awemenu-megamenu").toggle(); // Toggle submenu visibility
//   $(".awemenu-submenu.awemenu-megamenu").css("visibility","visible"); 
//   $(".awemenu-submenu.awemenu-megamenu").css("opacity","1"); 
//   $(".awemenu-has-children").toggleClass("activeSubmenu");

//   // Set background color based on submenu visibility
//   if ($(".awemenu-submenu.awemenu-megamenu").is(":visible")) {
//       $(".awemenu-nav").css("background-color", "white");
//   } else {
//       $(".awemenu-nav").css("background-color", "transparent");
//   }
// });

// // Close submenu when clicking outside
// $(document).click(function (event) {
//   if (!$(event.target).closest(".sub-menu-link, .awemenu-submenu.awemenu-megamenu").length) {
//       $(".awemenu-submenu.awemenu-megamenu").hide();
//       $(".awemenu-submenu.awemenu-megamenu").css("visibility","hidden"); 
//   $(".awemenu-submenu.awemenu-megamenu").css("opacity","0"); 
//       $(".awemenu-has-children").removeClass("activeSubmenu");
//       $(".awemenu-nav").css("background-color", "transparent"); // Reset background
//   }
// });

// $(".awemenu-item > p").click(function (event) {
//   event.preventDefault(); // Prevent default link behavior
//   event.stopPropagation(); // Prevent event bubbling

//   let $submenu = $(this).siblings(".awemenu-submenu"); // Get the specific submenu

//   // Close all other submenus except the one being clicked
//   $(".awemenu-submenu").not($submenu).slideUp();
//   $(".awemenu-item").not($(this).parent()).removeClass("open");

//   // Toggle the clicked submenu
//   $submenu.slideToggle();
//   $submenu.css("visibility","visible");
//   $submenu.css("opacity","1");
//   $submenu.css("display","block");

//   $(this).parent().toggleClass("open");

//   // Check if any submenu is open to change header background
//   if ($(".awemenu-submenu:visible").length > 0) {
//       $(".awemenu-nav").css("background-color", "white");
//   } else {
//       $(".awemenu-nav").css("background-color", "transparent");
//   }
// });

// Close menu when clicking outside
// $(document).click(function (event) {
//   if (!$(event.target).closest(".awemenu-item").length) {
//       $(".awemenu-submenu").slideUp();
//       $(".awemenu-submenu").css("visibility","hidden");
//       $(".awemenu-submenu").css("opacity","0");
//       $(".awemenu-submenu").css("display","none");
//       $(".awemenu-item").removeClass("open");
//       $(".awemenu-nav").css("background-color", "transparent"); // Reset background
//   }
// });


  /* Top Nav menu item hover change the menu background color */
  // $(".awemenu-item").click(function () {
  //   //if ($(this).hasClass("awemenu-has-children")) {
  //     $(".awemenu-nav").css("background-color", "white");
  //   //}
  // });
  // $(".awemenu-item").mouseout(function () {
  //   $(".awemenu-nav").css("background-color", "transparent");
  // });
  /* PDP select options click in the sticky bar - scroll to top */
  $(".productOptions a").click(function (e) {
    // $("html, body").animate({ scrollTop: 0 }, "slow");
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $(".product-details-wrapper ul").offset().top,
        },
        1000,
        "linear"
      );
  });
  /*Show Mobile Menu*/

   
    
   
  $(".mobileHamburger").click(function (e) {
    $(".mobileMenu").addClass("openMobileMenu");
    $(".mobileMenuOverlay").show();
    $(this).addClass("close");
    $(".closeMobileMenu").addClass("active");
    $(".awemenu-nav").addClass("active");
    // $("html").css("overflow","hidden");
  });
  $(".closeMobileMenu").click(function (e) {
    $(".mobileMenu").removeClass("openMobileMenu");
    $(".mobileMenuOverlay").hide();
    $(".awemenu-nav").removeClass("active");
    $(".mobileHamburger").removeClass("close");
    $(this).removeClass("active");
    // $("html").css("overflow","initial");
  });
  $(".closeIcon").click(function (e) {
    $(".teamPopup").removeClass("teamPopupOpen");
  });
  /* Mobile Menu - Show subMenu */
  $(".hasChild a").click(function (e) {
    if ($(this).parent("li").children(".subMenu").css("display") == "none") {
      $(this).parent("li").children(".subMenu").slideDown();
      //console.log("mousehover");
      $(this).addClass("active");
    } else {
      $(this).parent("li").children(".subMenu").slideUp();
      $(this).removeClass("active");
      //console.log("mouseOUT");
    }
  });
  /*PDP Write Review*/

  $(".writeReview a").click(function (e) {
    var formID = $("#shopify-product-reviews").attr("data-id");
    $("#form_" + formID).show();
  });
  /* PDP Spec Accordion */
  $(".productSpecsSection a").click(function (e) {
    if (
      $(this).parent(".productSpecsSection").children("ul").css("display") ==
      "none"
    ) {
      $(this).parent(".productSpecsSection").children("ul").slideDown();
      $(this).addClass("active");
    } else {
      $(this).parent(".productSpecsSection").children("ul").slideUp();
      $(this).removeClass("active");
    }
  });
  /*Show Team Popup*/
  $(".showTeamPopup").click(function (e) {
    var name = $(this).parent("li").children("h4").html();
    var designation = $(this).parent("li").children("h5").html();
    var description = $(this).parent("li").children("p").html();
    var image = $(this).parent("li").children("img").attr("src");
    
    if(designation!=undefined)
    {
      $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("h5")
      .html(designation);
       $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("h5")
      .show();
    }
    else
    {
      $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("h5")
      .hide();
    }
    $(".teamPopup")
      .children(".contentSection")
      .children(".imageBlock")
      .children("img")
      .attr("src", image);
     $(".teamPopup")
      .children(".contentSection")
      .children(".imageBlock")
      .children("img")
      .attr("alt", name);
    $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("h4")
      .html(name);
    
    $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("p")
      .html(description);
    $(".teamPopup").addClass("teamPopupOpen");
  });
  $(".showAboutTeamPopup").click(function (e) {
    var name = $(this).parent("li").children("h4").html();
    var designation = $(this).parent("li").children("h5").html();
    var description = $(this).parent("li").children("p").html();
    var image = $(this)
      .parent("li")
      .children(".imageWrapper")
      .children(".teamPopUpImage")
      .attr("src");
    
    if(designation!=undefined)
    {
      $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("h5")
      .html(designation);
       $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("h5")
      .show();
    }
    else
    {
      $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("h5")
      .hide();
    }
    $(".teamPopup")
      .children(".contentSection")
      .children(".imageBlock")
      .children("img")
      .attr("src", image);
     $(".teamPopup")
      .children(".contentSection")
      .children(".imageBlock")
      .children("img")
      .attr("alt", name);
    $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("h4")
      .html(name);
   
    $(".teamPopup")
      .children(".contentSection")
      .children(".contentBlock")
      .children("p")
      .html(description);
    $(".teamPopup").addClass("teamPopupOpen");
  });
  // /* Show Doctor Login */
  // $('.ShowDoctorLogin').click(function (e) {
  // $('#loginSection').show();
  // $("#doctorLogin").hide();
  // $("#loginHeading").html('Doctor Sign In')
  // });
  /* Show Doctor Register */
  $(".ShowDoctorRegister").click(function (e) {
    $("#doctorRegister").hide();
    $("#createAccountHeading").html("Create a Doctor Account");
  });
  $(".txt-form").each(function (index) {
    if ($(this).children(".form-control").val() != "") {
      $(this).addClass("has-value");
    }
  });
  // on focus
  $(".form-group input").focus(function () {
    $(this).parent().addClass("has-value");
  });
  // blur input fields on unfocus + if has no value
  $(".form-group input").blur(function () {
    var text_val = $(this).val();
    if (text_val === "") {
      $(this).parent().removeClass("has-value");
    }
  });
  $(".form-group textarea").focus(function () {
    $(this).parent().addClass("has-value");
  });
  // blur input fields on unfocus + if has no value
  $(".form-group textarea").blur(function () {
    var text_val = $(this).val();
    if (text_val === "") {
      $(this).parent().removeClass("has-value");
    }
  });
  $(".form-group label").click(function () {
    $(this).parent().addClass("has-value");
  });
  


  /* PDP
  RADIO BUTTON CLICK WORKING */
  /* on Page load Get the value of the checked radio button for all the types
  get the name and value e.g. name = color, value = red */ 
  var variantCount = 0;
  var variantArray = [];
  var variantOptionArray = {};
  $(
    ".js-fieldset-variant .variantsRadioSectionOption .variantsRadioOption input:checked"
  ).each(function (index) {
    var variantKey = $(this).attr("name");
    var variantValue = $(this).val();
    /* Adding a map of name to value */
    variantOptionArray[variantKey] = variantValue;
    variantCount++;
//     console.log("variantCount: " + variantCount);
  });

  /*
  on page load hide the recharge options and the add to cart button
  */
  setTimeout(function () {
    $('#rc_container').hide();
    variantMatched();
    // disableInvalidOptions();
  }, 5000);
  $('.js-add-to-cart-btn').addClass("btn-disabled");
  $('.js-add-to-cart-btn').prop('disabled', true);
  /* 
  on page load
  Call the variant matched function to see if there is a match for the selected variants 
  */
  variantMatched();
  setTimeout(function () {
  
    disableInvalidOptions();
  }, 1000);
  
  
function disableInvalidOptions() {
  var key = null;
  var optionNumber = -1;

  var keyValues = {};

  $(".js-fieldset-variant .variantsRadioSectionOption .variantsRadioOption").each(function (index) {
      var displayVariantKey = $(this).attr("name");
      var displayVariantValue = $(this).val();
      var displayElem = $(this);

      if (displayVariantKey) {

          if (key != displayVariantKey) {
              optionNumber += 1;
              key = displayVariantKey;
              firstDisplayElem = displayElem;
          }
          console.log("optionNumber"+optionNumber)
          console.log("displayVariantKey"+displayVariantKey)
          // look up drop down
          var inDropdown = false;
         
          
          if (optionNumber == 0) {
              $("#productSelect-option-0").each(function (index) {
                  var dropdownValue = $(this).val();
                  if($("#productSelect-option-0 option[value='" + displayVariantValue + "']").length > 0) {
                      inDropdown = true;
                  }
              });
          } else if (optionNumber == 1) {
              $("#productSelect-option-1").each(function (index) {
                
                  var dropdownValue = $(this).val();
                  if($("#productSelect-option-1 option[value='" + displayVariantValue + "']").length > 0) {
                      inDropdown = true;
                  }
              });
          } else if (optionNumber == 2) {
              $("#productSelect-option-2").each(function (index) {
                  var dropdownValue = $(this).val();
                  if($("#productSelect-option-2 option[value='" + displayVariantValue + "']").length > 0) {
                      inDropdown = true;
                  }
              });
          }

//           console.log("displayVairantKey: " + displayVariantKey);
//           console.log("displayVariantValue: " + displayVariantValue);
//           console.log("key: " + key);
//           console.log("optionNumber: " + optionNumber);
//           console.log("inDropDown: " + inDropdown);

console.log("inDropdown"+inDropdown);
console.log("inDropdown Html"+$(displayElem).parent().children("label").html());
          if (inDropdown == false) {
              $(displayElem).parent().children("label").addClass('disabled');
              $(displayElem).parent().children("input").attr("disabled", true);
              $(displayElem).parent().children("input"). prop("checked", false);
          } else {
              $(displayElem).parent().children("label").removeClass('disabled');
              $(displayElem).parent().children("input").attr("disabled", false);
          }
      }
  });
  // variantMatched();
  checkedValidOptions();
}
function checkedValidOptions() {
  var key = null;
  var optionNumber = -1;

  $(".js-fieldset-variant .variantsRadioSectionOption .variantsRadioOption").each(function (index) {
      var displayVariantKey = $(this).attr("name");
      var displayVariantValue = $(this).val();
      var displayElem = $(this);

      if (displayVariantKey) {

          if (key != displayVariantKey) {
              optionNumber += 1;
              key = displayVariantKey;
              firstDisplayElem = displayElem;
          }

          // look up drop down
          var doCheck = false;
          if (optionNumber == 0) {
              $("#productSelect-option-0").each(function (index) {
                  var dropdownValue = $(this).val();

                  if(dropdownValue == displayVariantValue) {
                    doCheck = true;
                  }
              });
          } else if (optionNumber == 1) {
              $("#productSelect-option-1").each(function (index) {
                  var dropdownValue = $(this).val();

                  if(dropdownValue == displayVariantValue) {
                    doCheck = true;
                  }
              });
          } else if (optionNumber == 2) {
              $("#productSelect-option-2").each(function (index) {
                  var dropdownValue = $(this).val();

                  if(dropdownValue == displayVariantValue) {
                    doCheck = true;
                  }
              });
          }

//           console.log("displayVairantKey: " + displayVariantKey);
//           console.log("displayVariantValue: " + displayVariantValue);
//           console.log("key: " + key);
//           console.log("optionNumber: " + optionNumber);
//           console.log("doCheck: " + doCheck);

          if (doCheck == true) {
              $(displayElem).parent().children("input").prop("checked", true);
              // $(displayElem).parent().children("label").trigger("click");
              // $(displayElem).parent().children("input").click();
              variantSelection($(displayElem).parent().children("label"));
          }
      }
  });
}
function variantMatched()
  {
    var matched = 0;
  /* 
  Go through all hidden variants
  for each hidden variant check if the variantOptionArray value is present in the hidden variant name
  e.g. variantoptionarray = {size->24-pack, color->blue}, hidden variant name = 24-Pack/Blue, 24-pack/Red

  */

  
  if (prodLib.length == 0) {
    let selectedVariantID = $('.js-add-to-cart-btn').attr('data-attr-itemid');
    console.log("selectedVariantID: when NULL: " + selectedVariantID)
    $('.js-add-to-cart-btn').removeClass("btn-disabled");
    $('.js-add-to-cart-btn').prop('disabled', false);
    $('#rc_container').show();
  } 
  else{
    $(".variantsRadio").each(function (index) {
      /* Hidden variant name and price in a variable */
      var variantName = $(this).children("label").text();
      var variantPrice = $(this).children("input").attr("data-variant-price");
//       console.log("VariantPrice: " + variantPrice);
      var matched = 0;
      /*
      hidden varitant 
      name = 24-pack/red
      price = 24.00
  
      name = 24-pack/blue
      price = 30.00
      */
      $.each(variantOptionArray, function (key, value) {
        /* Check the subsstring of the hidden variant 
        match = 1
        matchin = 2
        */
  
        if (variantName.indexOf(value) >= 0) {
          matched++;
//           console.log("TRUE: " + variantName + " : matched: " + matched);
         //  $('.js-add-to-cart-btn').show();
        }
        else{
          // hide add to cart button
         //  $('.js-add-to-cart-btn').hide();
        }
      });
//       console.log("length: " + Object.keys(variantOptionArray).length);
  
      /* If all the options are matched of the selected radio buttons
      then
      the variable matched should be EQUAL to the size of the variantOptionArray
      If true
      update the Onetime and Subscrition values next to each other */
      if (matched == Object.keys(variantOptionArray).length) {
        $('.js-add-to-cart-btn').removeClass("btn-disabled");
        $('.js-add-to-cart-btn').prop('disabled', false);
        $('#rc_container').show();
      

     
        subcriptionPercentage = $('.rc_label__discount').html();
        console.log("sub percentage", subcriptionPercentage);
        try{
          subcriptionPercentage = subcriptionPercentage.match(/\(Save ([0-9]+)%\).*/)[1];
        }
        catch{

        }
        subcriptionPercentage = parseInt(subcriptionPercentage);
        calculaterSubscriptionPercentage = (100-subcriptionPercentage)/100
     
        
//         console.log("subcriptionPercentage: " +  subcriptionPercentage);
//         console.log("Discount: " + $('.rc_label__discount').html());
//         console.log("THIS IS THE MATCHED VARIANT: " + variantName);
//         console.log("THIS IS THE MATCHED VARIANT PRICE: " + variantPrice);
        
        
        var money = variantPrice;
        var moneyAsNum = money * 1;
        $("#rc_price_onetime").parent().find(".overlay").remove();
        var oneTime = $("#rc_price_onetime").parent().html();
        $("#rc_price_onetime")
          .parent()
          .html(
            oneTime + '<span class="overlay">$ ' + moneyAsNum + " USD</span>"
          );
        $("#rc_price_autodeliver").parent().find(".overlay").remove();
        var autodeliver = $("#rc_price_autodeliver").parent().html();
        $("#rc_price_autodeliver")
          .parent()
          .html(
            autodeliver +
              '<span class="overlay">$ ' +
              (moneyAsNum * calculaterSubscriptionPercentage).toFixed(2) +
              " USD (Save "+subcriptionPercentage+"%)</span>"
          );
          try
          {
        var first = $("#rc_price_onetime").position();
        var second = $("#rc_price_autodeliver").position();
        $("#rc_price_onetime").parent().attr("style", "position:relative;");
        $("#rc_price_autodeliver")
          .parent()
          .attr("style", "position:relative;");
        $("#rc_price_onetime")
          .parent()
          .find(".overlay")
          .attr(
            "style",
            "left:" +
              first.left +
              "px;position:relative;background:white;position:absolute;width: 100%;"
          );
        $("#rc_price_autodeliver")
          .parent()
          .find(".overlay")
          .attr(
            "style",
            "left:" +
              second.left +
              "px;position:relative;background:white;position:absolute;width: 100%;"
          );
        }
        catch{}
      }
      
     //  else{
     //    // Hide add to cart button
     //   $('.js-add-to-cart-btn').hide();
     //  }
    });    
  }



  
}
function variantSelection(passedElement)
{ 
  $('.js-add-to-cart-btn').addClass("btn-disabled");
  $('.js-add-to-cart-btn').prop('disabled', true);
  $('#rc_container').hide();
  /*
  Get the clicked radio button  name and value
  */
  var variantValue = $(passedElement)
    .parent(".variantsRadioOption")
    .children("input")
    .val();

  var variantLabel = passedElement.innerText;



  var variantKey = $(passedElement)
    .parent(".variantsRadioOption")
    .children("input")
    .attr("name");
    console.log("clicked variantValue: " + variantValue);
    console.log("clicked variantKey: " + variantKey);

  /* Check if the key exists in the array or not 
 if it exists, then update the key with the new value
 e.g. on load color = red
 but on click  - color = blue
 */
  if (variantKey in variantOptionArray) {
   if(variantKey == 'quantity') {
   /* Commented this code out in order to stop the product image carousel from
      auto-advancing on quantity variant selection / page load. Images should
      only change via arrows, swipe, or thumbnail clicks. - Oscar
                    $productDetailImages.trigger('refresh.owl.carousel');
                 $productDetailImages.trigger('to.owl.carousel', 1)
//   $(".productDetailImages .owl-item").each(function () {
//      if($(this).attr("class") == 'owl-item active') {//       $(this).attr("class",'owl-item')
//       }
//   })
   var intOffset = 0
   var strCurrentProduct =  $('input[name="lx-product"]:checked').val()
     console.log('Product Selection currently is: ' + strCurrentProduct)
   $(".productDetailImages .owl-item").each(function () {
      var srcimage = $(this).children("li").children("img").attr("src");
      var altText = $(this).children("li").children("img").attr("alt");
      var theClass = $(this).attr("class")
      var imageIndex = $(this).index()
      if(theClass != 'owl-item cloned') {
        intOffset++
        if(altText.includes(strCurrentProduct)){
 //         console.log('The index to select is:' + intOffset)
          $(this).attr("class",'owl-item active')
                  $productDetailImages.trigger('refresh.owl.carousel');
                 $productDetailImages.trigger('to.owl.carousel', intOffset-1)
         return false
        }}}
    )
   */
   };
    
    // console.log(variantKey);
    variantOptionArray[variantKey] = variantValue;
    // if key exists, then don't do anything
  }
//   console.log("after checking variantKey in array - show the array  below")
//   console.log(variantOptionArray);
  /* Call the matched function */
//   console.log("Calling the matched function");
  variantMatched();
  // disableInvalidOptions();
  /* Update the drop down values with the variant radio button selected */

  var selectID = $(passedElement)
    .parent(".variantsRadioOption")
    .parent("div")
    .parent("fieldset")
    .attr("id")
    .replace("P", "p");
  $("#" + selectID).val(variantValue);
  $("#" + selectID).change();
}
/*
PDP: Radio Button Click
*/
    $('.buttonImages').click(function(e) {
      let checkVal = $(this).val();
      $(`label[for="ProductSelect-option-lx-product-${checkVal}"]`).click();
    })

    $('.dot').click(function(e) {
      let checkVal = $(this).val();
      $(`label[for="ProductSelect-option-lx-product-${checkVal}"]`).click();
    })

   $(".product-actions-wrapper .optionRadio").click(function (e) {
     console.log("------------------------- CLICK------------------");
      variantSelection(this);
      disableInvalidOptions();
   });


 
});
/* Product hover on the collection page and search page */
$(".product-inner").each(function (index) {
  var count = $(this)
    .children(".product-media")
    .children(".product-thumbnail")
    .children("a")
    .children().length;
  //console.log(count);
  if (count > 1) {
    $(this)
      .children(".product-media")
      .children(".product-thumbnail")
      .children("a")
      .children("img")
      .css("opacity", "0");
    $(this)
      .children(".product-media")
      .children(".product-thumbnail")
      .children("a")
      .children("img:nth-child(1)")
      .css("opacity", "1");
  }
});
/* on Mouse over change the image*/
$(".product-inner").mouseover(function () {
  var width = $(document).width();
  if (width > 980) {
    var count = $(this)
      .children(".product-media")
      .children(".product-thumbnail")
      .children("a")
      .children().length;
    if (count > 1) {
      $(this)
        .children(".product-media")
        .children(".product-thumbnail")
        .children("a")
        .children("img")
        .removeClass("current");
      if (count > 3) {
        $(this)
          .children(".product-media")
          .children(".product-thumbnail")
          .children("a")
          .children("img:nth-child(3)")
          .css("opacity", "1");
        $(this)
          .children(".product-media")
          .children(".product-thumbnail")
          .children("a")
          .children("img:nth-child(1)")
          .css("opacity", "0");
      } else {
        //console.log ("countr LESS THAN 3");
        $(this)
          .children(".product-media")
          .children(".product-thumbnail")
          .children("a")
          .children("img:nth-child(1)")
          .css("opacity", "0");
        $(this)
          .children(".product-media")
          .children(".product-thumbnail")
          .children("a")
          .children("img:nth-child(2)")
          .css("opacity", "1");
      }
    }
    // ends
  }
});
/* On mouse out revert it back to the original image */
$(".product-inner").mouseout(function () {
  //console.log("mouse OUT");
  var width = $(document).width();
  if (width > 980) {
    $(this)
      .children(".product-media")
      .children(".product-thumbnail")
      .children("a")
      .children(".image__container")
      .removeClass("current");
    var count = $(this)
      .children(".product-media")
      .children(".product-thumbnail")
      .children("a")
      .children().length;
    if (count > 1) {
      $(this)
        .children(".product-media")
        .children(".product-thumbnail")
        .children("a")
        .children("img")
        .css("opacity", "0");
      $(this)
        .children(".product-media")
        .children(".product-thumbnail")
        .children("a")
        .children("img:nth-child(1)")
        .css("opacity", "1");
    }
  }
});
$(window).scroll(function () {
  if ($(this).scrollTop() > 200) {
    if ($(this).scrollTop() > $("footer").offset().top - 400) {
      $(".paginationBlogSection").removeClass("fixedBlogPagination");
    } else {
      $(".paginationBlogSection").addClass("fixedBlogPagination");
    }
  } else {
    $(".paginationBlogSection").removeClass("fixedBlogPagination");
  }
});



$(document).ready(function ($) {
  /*Zoho dummy button click*/
  $(".dummy-zoho-submit").click(function (e) {
    var firstName=$(".dummy-txt-fname").val();
     var LastName=$(".dummy-txt-lname").val();
     var email=$(".dummy-txt-email").val();
    if(firstName!="" && LastName!=""  && email!="")
    {
       if (validateEmail(email)) {
         $(".zoho-txt-fname").val(firstName);
         $(".zoho-txt-lname").val(LastName);
         $(".zoho-txt-email").val(email);
         
         // Store
		 localStorage.setItem("zohoFirstName", firstName);
         localStorage.setItem("zohoLastName", LastName);
         localStorage.setItem("zohoEmail", email);
         $(".zoho-submit").click();
         
         
       }
      
    }
  }) 
  
  
})



function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}




/* Loop through couponArray to show message on PDP pages */
  function loopThroughCouponCodeArrayToShowMessageOnPDP()
  {
    let browserURL = $(location).attr("href");
  console.log(browserURL);
    
  let cartCouponDiscountCode = "";
    cartCouponDiscountCode = localStorage.getItem("couponCode");
    console.log("cartCouponDiscountCode: " + cartCouponDiscountCode);
              $('.js-show-pdp-coupon-message').hide();
 $.each(couponCodeArray, function (key, value) {
  console.log("CouponCodeValues: " + value);
    value = value.split("~");
   let couponCode = "";
   let couponMessage = "";
   let couponShowPageURL = "";
   couponCode = value[1];
   
          couponCode = value[1];
          couponMessage = value[2];
             couponShowPageURL = value[3];
   
    console.log("couponCode: " + couponCode);
       console.log("couponMessage: " + couponMessage);
       console.log("couponShowPageURL: " + couponShowPageURL);
   
   
   /* if coupon code and browser URL matches then show the notification*/
   if(browserURL == couponShowPageURL && cartCouponDiscountCode == couponCode)
   {
     console.log("URL is matched");
     console.log(couponMessage);

	$('.js-show-pdp-coupon-message').html(couponMessage);
          $('.js-show-pdp-coupon-message').show();
     
   }
     });
  }

  $(document).ready(function ($) {
    var newsHeight = $('.topBarSection').height();
    $('.mobileMenu').css("top", + (newsHeight + 60) + 'px');
    $('.awemenu-nav').css("top",  + (newsHeight) + 'px');
    
  });
  $(window).scroll(function () {
    try{

    
    var sticky = $("header");
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 30) {
      sticky.addClass("fixed");
      $('.awemenu-nav').addClass('fixedHeader');
      $('.topBarSection').addClass('hide');
      $('.mobileMenu').addClass("top-60");
    } else {
      $('.awemenu-nav').removeClass('fixedHeader');
      $('.topBarSection').removeClass('hide');
      $('.mobileMenu').removeClass("top-60");
    }
    if (scrollTop > $('.relatedProductSection').offset().top) {
      $('.productHeaderFixed').show();
    } else {
      $('.productHeaderFixed').hide();
    }
  }
  catch{}
  });
  